import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import cns from 'classnames';

class PageHeader extends Component {
    static propTypes = {
        title: PropTypes.string,
        subtitle: PropTypes.string,
        imageElements: PropTypes.any,
        custom: PropTypes.bool,
        customContainerClass: PropTypes.string,
        children: PropTypes.any,
        className: PropTypes.string,
        bottomBorder: PropTypes.bool,
        fullWidthTitle: PropTypes.bool
    };

    render() {
        const {
            title = '',
            subtitle = '',
            subtitleWithLink = '',
            imageElements = null,
            custom = false,
            customContainerClass = 'container',
            bottomBorder = false,
            children,
            fullWidthTitle = false
        } = this.props;
        if (custom) {
            return (
                <header className={cns('pageHeader', 'container-fluid', { bottomBorder }, this.props.className)}>
                    <div className={customContainerClass}>{children}</div>
                </header>
            );
        }

        return (
            <header className={cns('pageHeader', 'container-fluid', { bottomBorder }, this.props.className)}>
                <div className={'container'}>
                    <div>
                        <div className={cns('pageHeaderTitleSection col-12')}>
                            <h1 className={'verb-title-1 pageHeaderTitle'}>{title}</h1>
                            <h4 className={'pageHeaderSubtitle'}>{subtitle}</h4>
                            {subtitleWithLink}
                        </div>
                        <div className={'pageHeaderImages col-12 col-md-4'}>{imageElements}</div>
                    </div>
                </div>
            </header>
        );
    }
}

export default PageHeader;
